import { useState, useEffect } from 'react';
import { updatePopUpState } from '../../api/popUpApi';
import { FaRegCircleXmark } from 'react-icons/fa6';
import './Style.css';
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useFetchActivePopUp } from '../../data/swrs/popup';
import { useNavigate } from 'react-router-dom';
import Toast from '../../utils/toastManager';

const PopUpModal = () => {
	const [popupModal, setPopupModal] = useState(false);
	const { data: popup } = useFetchActivePopUp();
	const navigate = useNavigate();
	
	useEffect(() => {
		if (!popup?.data?.userCanView) return;

		const popupId = popup?.data?._id;
		if (!popupId) return;

		const popupKey = `popupClosed_${popupId}`;
		const wasClosed = localStorage.getItem(popupKey);

		if (wasClosed !== 'true') {
			setPopupModal(true);
		}
	}, [popup]);

	const handleClose = async () => {
		if (!popup?.data?._id) return;

		try {
			await updatePopUpState(popup.data._id);
			setPopupModal(false);
			localStorage.setItem(`popupClosed_${popup.data._id}`, 'true');
		} catch {
			Toast.error('Failed to close popup. Please try again.');
		}
	};

	const handleSecondaryCTAClick = () => {
		const redirectUrl = popup?.data?.secondaryCTA?.redirectUrl;
		redirectUrl ? (window.location.href = redirectUrl) : handleClose();
	};

	const handlePrimaryCTAClick = async () => {
		const redirectUrl = popup?.data?.primaryCTA?.redirectUrl;
		const popupId = popup?.data?._id;

		if (!popupId) return handleClose();

		const url = new URL(redirectUrl);
		const v = url.searchParams.get('v');
		const type = url.searchParams.get('type');
		const currentOrigin = window.location.origin;

		const isLocalhost = currentOrigin.includes('localhost') || currentOrigin.includes('127.0.0.1');
		const isOriginMatch = url.origin === currentOrigin || isLocalhost;

		await updatePopUpState(popupId);

		if (!redirectUrl) {
			return handleClose();
		}

		if (isOriginMatch && v && type) {
			navigate(`/PlayerPage?v=${v}&type=${type}`);
		} else {
			window.location.href = redirectUrl;
		}

		return handleClose();
	};

	if (!popupModal || !popup?.data?.userCanView) return null

	const { headerText, thumbnailLink, description, primaryCTA, secondaryCTA } = popup.data;

	return (
		<div className="popup-container">
			<div className="popup-body">
				<div className="popup-header">
					<h2>{headerText}</h2>
					<button className="popup-close-button" onClick={handleClose}>
						<FaRegCircleXmark color="white" size={20} />
					</button>
				</div>

				{thumbnailLink && (
					<div className="popup-thumbnail">
						<img src={thumbnailLink} alt="Popup Thumbnail" />
					</div>
				)}

				{description && <div className="popup-description">{description}</div>}

				<div className="popup-buttons">
					{/* {secondaryCTA?.text && (
						<button className="watch-later-button" onClick={handleSecondaryCTAClick}>
							{secondaryCTA.text}
						</button>
					)} */}

					{primaryCTA?.text && (
						<button className="To-video-button" onClick={handlePrimaryCTAClick}>
							{primaryCTA.text}
							<ArrowForwardIcon size={24} />
						</button>
					)}
				</div>
			</div>
		</div>
	);
};

export default PopUpModal;
